import React from "react";
import Chat from "@/elements/components/chat/chat";
import ChatMetadataProvider from "@/elements/components/chat/chat-metadata-provider";

function ChatScreen() {
  return (
    <ChatMetadataProvider>
      <Chat />
    </ChatMetadataProvider>
  );
}

export default ChatScreen;
